"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currentUserReducerBase = void 0;
var tslib_1 = require("tslib");
var getObjectFirstItem_1 = require("../../utilities/get/getObjectFirstItem");
var currentUserReducerBase = function (state, action) {
    if (!action) {
        return state || null;
    }
    if (action.type === 'SIGN_OUT_REQUEST_ACTION') {
        return tslib_1.__assign(tslib_1.__assign({}, state), { signingOut: true });
    }
    if (action.type === 'SIGN_IN_SUCCESS') {
        var user = action.user;
        var email = user.email, displayName = user.displayName;
        var cleanedEmail = email === null || email === void 0 ? void 0 : email.trim().toLowerCase();
        return tslib_1.__assign(tslib_1.__assign({}, user), { email: cleanedEmail, displayName: displayName || (state === null || state === void 0 ? void 0 : state.displayName) || 'Unknown' });
    }
    if (action.type === 'PATCH_USERS_SUCCESS') {
        var item = (0, getObjectFirstItem_1.getObjectFirstItem)(action.successValues.items).item;
        return tslib_1.__assign(tslib_1.__assign({}, state), item);
    }
    if (action.type === 'SIGN_OUT_SUCCESS') {
        return null;
    }
    return state || null;
};
exports.currentUserReducerBase = currentUserReducerBase;
